__turbopack_context__.v({
  "active": "HIWStep-module-scss-module__2myynq__active",
  "checklist": "HIWStep-module-scss-module__2myynq__checklist",
  "heading": "HIWStep-module-scss-module__2myynq__heading",
  "wrapper": "HIWStep-module-scss-module__2myynq__wrapper",
});
